import React from 'react';
import { shape, func, string, arrayOf, bool } from 'prop-types';
import ReactSelect, { components } from 'react-select';

import Icon from 'components/icon';
import Forms from '.';

export const classNamePrefix = 'react-select-custom';

const DropdownIndicator = props => (
    <components.DropdownIndicator {...props}>
        <div
            className={`dropdown-indicator ${
                // eslint-disable-next-line react/prop-types
                props.selectProps.menuIsOpen ? 'is-open' : ''
            }`}
        >
            <Icon glyph="arrow-drop-down" />
        </div>
    </components.DropdownIndicator>
);

const Select = ({
    disabled,
    flatBottom,
    inlineLabel,
    label,
    labelIsBold,
    labelIsHidden,
    medium,
    name,
    noBorder,
    options,
    placeholder,
    value,
    onChange,
    readOnly,
    small
}) => {
    const selectedOption = options.find(option => option.value === value);
    const containerClassName = `${classNamePrefix} ${
        small ? 'react-select-custom--small' : ''
    } ${medium ? 'react-select-custom--medium' : ''} ${
        noBorder ? 'react-select-custom--no-border' : ''
    }`;

    if (!options || !options.length) {
        return null;
    }

    return (
        <Forms.FormGroup
            flatBottom={flatBottom}
            htmlFor={name}
            inlineLabel={inlineLabel}
            label={label}
            labelIsBold={labelIsBold}
            labelIsHidden={labelIsHidden}
        >
            <ReactSelect
                className={containerClassName}
                classNamePrefix={classNamePrefix}
                components={{ DropdownIndicator }}
                id={name}
                isDisabled={disabled}
                isSearchable={false}
                name={name}
                onChange={onChange}
                options={options}
                placeholder={placeholder}
                readOnly={readOnly}
                value={
                    (selectedOption && selectedOption.value === '') ||
                    !selectedOption
                        ? null
                        : selectedOption
                }
            />
        </Forms.FormGroup>
    );
};

Select.propTypes = {
    disabled: bool,
    flatBottom: bool,
    inlineLabel: bool,
    label: string.isRequired,
    labelIsBold: bool,
    labelIsHidden: bool,
    medium: bool,
    name: string.isRequired,
    noBorder: bool,
    onChange: func,
    options: arrayOf(shape({ value: string, label: string })).isRequired,
    placeholder: string,
    readOnly: bool,
    small: bool,
    value: string
};

export default Select;
